import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/common/Layout'
import MapGrid from '../components/community/MapGrid'
import { Link } from 'gatsby'
import * as styles from '../components/community/MapCollection.module.scss'
import PageHeader from '../components/community/PageHeader'

const MapCollectionPage = ({ data, pageContext }) => {
  const { collectionName } = pageContext
  const maps = data?.maps?.nodes || []

  return (
    <Layout
      title={`${collectionName} GIS Templates - Atlas`}
      meta={{
        description: `Explore our collection of ${collectionName} templates. Find templates, examples, and solutions for ${collectionName}.`,
        title: `${collectionName} GIS Templates - Atlas`,
        type: 'website'
      }}
    >
      <main>
        <PageHeader
          title={`${collectionName} Templates`}
          subtitle={
            'Explore our collection of ' +
            maps.length +
            ' templates for ' +
            collectionName
          }
        />

        <MapGrid maps={maps} small />
      </main>
    </Layout>
  )
}

export default MapCollectionPage

export const pageQuery = graphql`
  query MapCollectionPage($collectionName: String!) {
    maps: allMarkdownRemark(
      sort: { frontmatter: { created: DESC } }
      filter: {
        fileAbsolutePath: { regex: "/content/maps/" }
        frontmatter: {
          collections: { in: [$collectionName] }
          draft: { ne: true }
        }
      }
      limit: 100
    ) {
      nodes {
        id
        frontmatter {
          title
          featuredImage
          link
          featured
          collections
          products
          created
          description
          draft
        }
      }
    }
  }
`
